module.exports = __webpack_public_path__ + "static/media/video.a41c1787.svg";